/**
 * GeneralCalendarPage - Wrapper for CalendarTab when used outside workspace context
 * 
 * This page provides the same month/week calendar functionality as the workspace
 * calendar tab, but shows ALL events (not filtered by workspace).
 */

import React from 'react';
import PageShell from '../components/PageShell';
import CalendarTab from '../components/workspace/tabs/CalendarTab/CalendarTab';
import type { CalendarEventSource } from '../types/calendar';

// Legislative + the caller's own workspace events — workspace events are
// cross-cutting and appear on both calendars (CALENDAR_SEPARATION_PRD §5.2b,
// resolved O2). Module-level so hook identities stay stable.
const LEGISLATIVE_SOURCES: CalendarEventSource[] = ['legislative', 'workspace'];

const GeneralCalendarPage: React.FC = () => {
  /*
    P3-08: registers the page with the global header, which was blank here —
    Bills and Budget name themselves there, this page did not, so moving between
    them looked like two different apps.

    No `showHeading`: CalendarTab already renders its own "Legislative Calendar"
    heading in the body, and a second one would repeat it. The header gains the
    name; the body is untouched.
  */
  return (
    <PageShell
      title="Legislative Calendar"
      description="Track upcoming legislative events and hearings"
      helpContentKey="workspace-calendar"
    >
      {/* Standalone: legislative + the user's workspace events (§5.2b) */}
      <CalendarTab hideHeading sources={LEGISLATIVE_SOURCES} />
    </PageShell>
  );
};

export default GeneralCalendarPage;

